import Carousel from "../Carousel";

const assetBucket = "https://dwxmfgxgcusc8.cloudfront.net";
const ImageBanner = () => {
  return Carousel({
    images: [
      {
        alt: "example wedding floral arrangement",
        src: `${assetBucket}/IMG_2513.jpeg`,
      },
      {
        alt: "example wedding floral arrangement",
        src: `${assetBucket}/dsc_9080.jpeg`,
      },
      // {
      //   alt: "example wedding floral arrangement",
      //   src: `${assetBucket}/IMG_1039.jpeg`,
      // },
      {
        alt: "example wedding floral arrangement",
        src: `${assetBucket}/IMG_1060.jpeg`,
      },
      // {
      //   alt: "example wedding floral arrangement",
      //   src: `${assetBucket}/dsc_9108.jpeg`,
      // },
      {
        alt: "example wedding floral arrangement",
        src: `${assetBucket}/IMG_9716.jpeg`,
      },
      {
        alt: "example wedding floral arrangement",
        src: `${assetBucket}/IMG_3371.jpeg`,
      },
      // {
      //   alt: "example wedding floral arrangement",
      //   src: `${assetBucket}/IMG_8239.jpeg`,
      // },
    ],
  });
};

export default ImageBanner;
